


































import { Component, Inject, InjectReactive, Vue } from 'vue-property-decorator';

import { Org } from '@/api';
import AddOrgToProduct from '@/components/add business objects/addOrgToProduct.vue';
import { FeedProduct } from '../../../models';
import { FeedProductService } from '../../../services/feed-product-service';
import { partnerFields } from '@/models/partner-org-table-fields';
import { BvTableFieldArray } from 'bootstrap-vue';

@Component({
	components: {
		AddOrgToProduct,
	},
})
export default class FeedProductPartnerOrgsTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@Inject('refreshFeedProduct')
	public refreshFeedProduct!: () => Promise<void>;

	@Inject('feedProductService')
	private service!: FeedProductService;

	@InjectReactive('feedPartnerOrgs')
	public partnerOrgs!: Org[];

	public get partnerTableFields(): BvTableFieldArray {
		return partnerFields;
	}
}
